import { faCancel, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import Select from 'react-select';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import _ from 'lodash-es';

export default class AddDailyTimesheetDetailButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showModal: false, selectedContractId: null };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    hideAndUnset = () => {
        this.setState({ showModal: false, selectedContractId: null });
    };

    toContractDisplay = (contract) =>
        `${contract.companyName} - ${contract.number} - ${contract.description}`;

    onContractChange = (e) => {
        const selectedContractId = e && e.id ? e.id : null;

        this.setState({ selectedContractId });
    };

    getOrderedContracts = () => {
        const { contracts } = this.props;

        return _.orderBy(
            contracts,
            ['companyName', 'number', 'description'],
            ['asc', 'asc', 'asc']
        );
    };

    addNewDetail = () => {
        const { selectedContractId } = this.state;

        if (!selectedContractId) {
            return;
        }

        const { dailyTimesheet, onDailyTimesheetMutated } = this.props;

        dailyTimesheet.dailyTimesheetDetails.push({
            contractId: selectedContractId,
        });

        onDailyTimesheetMutated(dailyTimesheet);

        this.setState({ showModal: false, selectedContractId: null });
    };

    render() {
        const orderedContracts = this.getOrderedContracts();
        const { loading, saving } = this.props;
        const { showModal, selectedContractId } = this.state;

        return (
            <div className="text-center">
                <Button
                    type="button"
                    color="success"
                    disabled={loading || saving}
                    onClick={this.toggleModal}
                    size="lg"
                    className="w-75"
                >
                    <FontAwesomeIcon icon={faPlusCircle} className="mr-1" /> Add
                    Another Job
                </Button>

                <Modal isOpen={showModal} toggle={this.toggleModal} size="xl">
                    <ModalHeader toggle={this.toggleModal}>
                        Add Another Job
                    </ModalHeader>

                    <ModalBody>
                        <div>
                            If you worked on a job that isn't listed on your
                            timesheet (or worked multiple phases), you can add
                            it here.
                        </div>

                        <Select
                            options={orderedContracts}
                            getOptionLabel={(c) => this.toContractDisplay(c)}
                            getOptionValue={(c) => c.id}
                            onChange={this.onContractChange}
                            value={
                                orderedContracts.find(
                                    (c) => c.id == selectedContractId
                                ) || ''
                            }
                        />
                    </ModalBody>

                    <ModalFooter>
                        <Button
                            type="button"
                            color="warning"
                            onClick={this.hideAndUnset}
                            className="mr-auto"
                        >
                            <FontAwesomeIcon icon={faCancel} className="mr-1" />
                            Cancel
                        </Button>

                        <Button
                            type="button"
                            color="success"
                            disabled={!selectedContractId}
                            outline={!selectedContractId}
                            onClick={this.addNewDetail}
                        >
                            <FontAwesomeIcon
                                icon={faPlusCircle}
                                className="mr-1"
                            />
                            Add Entry
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
